export default "<h1 mat-dialog-title>{{data.title}}</h1>\n<div mat-dialog-content>\n  {{data.content}}\n</div>";